// Turno24: botón "Comprar ahora" (directo al checkout con Flow), selector de packs con lonchera
// opcional, barra de envío gratis y sugerencias del carrito lateral.
if (!window.t24Upsell) {
  window.t24Upsell = true;

  const formatMoney = (cents, format) => {
    const value = Math.round(cents) / 100;
    const group = (sep) => Math.floor(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, sep);
    const decimals = (cents % 100).toString().padStart(2, '0');
    const amounts = {
      amount: `${group(',')}.${decimals}`,
      amount_no_decimals: group(','),
      amount_with_comma_separator: `${group('.')},${decimals}`,
      amount_no_decimals_with_comma_separator: group('.'),
      amount_with_apostrophe_separator: `${group("'")}.${decimals}`,
    };
    return (format || '${{amount_no_decimals}}').replace(/\{\{\s*(\w+)\s*\}\}/, (match, key) => amounts[key] ?? group('.'));
  };

  const postJSON = async (url, body) => {
    const response = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
    const json = await response.json().catch(() => ({}));
    if (!response.ok || json.status) throw new Error(json.description || json.message || 'No pudimos agregar el producto.');
    return json;
  };

  const productForm = (formId) => document.getElementById(formId);
  const buyboxFor = (formId) => document.querySelector(`[data-t24-buybox][data-form="${formId}"]`);
  const quantityInputFor = (formId) => document.querySelector(`.quantity__input[form="${formId}"]`);

  const selectedPack = (buybox) => Number(buybox.querySelector('.t24-packs input:checked')?.value || 1);

  // Variante de la lonchera marcada en el selector de la ficha, o null si no se marcó.
  const selectedAddon = (buybox) => {
    if (!buybox?.querySelector('[data-t24-addon-check]')?.checked) return null;
    const variant = buybox.querySelector('[data-t24-addon-variant]:checked, input[type="hidden"][data-t24-addon-variant]');
    return variant ? Number(variant.value) : null;
  };

  const updateBuybox = (buybox) => {
    const d = buybox.dataset;
    const pack = selectedPack(buybox);
    const unit = Number(d.unit);
    const packTotal = unit * pack - (pack === 3 ? Number(d.discountPack3) : pack === 2 ? Number(d.discountPack2) : 0);
    const addonPrice = Number(d.addonPrice);
    const withAddon = selectedAddon(buybox) !== null;
    const total = packTotal + (withAddon ? addonPrice : 0);
    const threshold = Number(d.threshold);
    const missing = threshold - total;
    const money = (cents) => formatMoney(cents, d.moneyFormat);

    const quantity = quantityInputFor(d.form);
    if (quantity) quantity.value = pack;

    const message = buybox.querySelector('[data-t24-ship-msg]');
    if (missing <= 0) {
      message.innerHTML = '✓ <b>Tu envío es gratis</b> a todo Chile';
    } else if (!withAddon && addonPrice > 0 && total + addonPrice >= threshold) {
      message.innerHTML = `Te faltan ${money(missing)}: <b>suma la lonchera y tu envío sale gratis</b>`;
    } else {
      message.innerHTML = `Te faltan <b>${money(missing)}</b> para el envío gratis`;
    }
    buybox.querySelector('[data-t24-ship-bar]').style.width = `${Math.min(100, Math.floor((total * 100) / threshold))}%`;

    const buyNowLabel = document.querySelector(`[data-t24-buy-now][data-form="${d.form}"] [data-t24-buy-now-label]`);
    if (buyNowLabel) buyNowLabel.textContent = `Comprar ahora · ${money(total)}`;
  };

  document.addEventListener('change', (event) => {
    const buybox = event.target.closest('[data-t24-buybox]');
    if (buybox) updateBuybox(buybox);
  });

  // Dawn vuelve la cantidad al mínimo al cambiar de talla o después de agregar al carrito:
  // se reaplica el pack elegido.
  if (typeof subscribe === 'function') {
    subscribe(PUB_SUB_EVENTS.quantityUpdate, () => {
      document.querySelectorAll('[data-t24-buybox]').forEach((buybox) => {
        const quantity = quantityInputFor(buybox.dataset.form);
        if (quantity) quantity.value = selectedPack(buybox);
      });
    });
  }

  // "Agregar al carrito" con la lonchera marcada: Dawn agrega las medias y después se suma la lonchera.
  let pendingAddon = null;
  document.addEventListener(
    'submit',
    (event) => {
      // getAttribute: en el formulario de producto, form.id es el input name="id", no el id del formulario.
      const formId = event.target.getAttribute('id');
      pendingAddon = formId ? selectedAddon(buyboxFor(formId)) : null;
    },
    true
  );
  if (typeof subscribe === 'function') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, async (event) => {
      if (event.source !== 'product-form' || !pendingAddon) return;
      const variantId = pendingAddon;
      pendingAddon = null;
      const cartDrawer = document.querySelector('cart-drawer');
      const state = await postJSON(`${routes.cart_add_url}.js`, {
        items: [{ id: variantId, quantity: 1 }],
        sections: cartDrawer ? ['cart-drawer', 'cart-icon-bubble'] : [],
        sections_url: window.location.pathname,
      }).catch(() => null);
      if (state && cartDrawer) cartDrawer.renderContents(state);
    });
  }

  const resetButton = (button) => {
    button.classList.remove('loading');
    button.removeAttribute('aria-disabled');
  };

  document.addEventListener('click', async (event) => {
    // "Comprar ahora": agrega lo elegido y va directo al checkout.
    const buyNow = event.target.closest('[data-t24-buy-now]');
    if (buyNow && !buyNow.classList.contains('loading')) {
      const form = productForm(buyNow.dataset.form);
      const addButton = form && form.querySelector('[name="add"]');
      if (!form || (addButton && addButton.disabled)) return;

      const errorWrapper = buyNow.closest('product-form').querySelector('.product-form__error-message-wrapper');
      errorWrapper.hidden = true;
      buyNow.classList.add('loading');
      buyNow.setAttribute('aria-disabled', 'true');

      const formData = new FormData(form);
      const items = [{ id: Number(formData.get('id')), quantity: Number(formData.get('quantity') || 1) }];
      const addon = selectedAddon(buyboxFor(buyNow.dataset.form));
      if (addon) items.push({ id: addon, quantity: 1 });

      try {
        await postJSON(`${routes.cart_add_url}.js`, { items });
        window.location.href = '/checkout';
      } catch (error) {
        errorWrapper.querySelector('.product-form__error-message').textContent = error.message;
        errorWrapper.hidden = false;
        resetButton(buyNow);
      }
      return;
    }

    // Carrito lateral: "Cambiar a 3" ajusta la cantidad de la línea como si la escribiera el cliente.
    const setQuantity = event.target.closest('[data-t24-set-quantity]');
    if (setQuantity) {
      const input = document.getElementById(`Drawer-quantity-${setQuantity.dataset.line}`);
      if (!input) return;
      setQuantity.classList.add('loading');
      input.value = setQuantity.dataset.quantity;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    // Carrito lateral: "+ Agregar" lonchera.
    const addAddon = event.target.closest('[data-t24-add-addon]');
    if (addAddon && !addAddon.classList.contains('loading')) {
      const select = addAddon.closest('.t24-upsell__row').querySelector('[data-t24-addon-select]');
      addAddon.classList.add('loading');
      try {
        const state = await postJSON(`${routes.cart_add_url}.js`, {
          items: [{ id: Number(select.value), quantity: 1 }],
          sections: ['cart-drawer', 'cart-icon-bubble'],
          sections_url: window.location.pathname,
        });
        document.querySelector('cart-drawer')?.renderContents(state);
      } catch (error) {
        addAddon.classList.remove('loading');
        const errors = document.getElementById('CartDrawer-CartErrors');
        if (errors) errors.textContent = error.message;
      }
    }
  });

  // Al volver atrás desde el checkout, la página sale de la caché con el botón cargando.
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) document.querySelectorAll('[data-t24-buy-now].loading').forEach(resetButton);
  });

  window.t24UpdateBuyboxes = () => document.querySelectorAll('[data-t24-buybox]').forEach(updateBuybox);
}

// También corre cuando el script se vuelve a inyectar (vista rápida): sincroniza el pack que el
// navegador haya restaurado con la cantidad, la barra y el botón.
window.t24UpdateBuyboxes();
